export default __webpack_public_path__ + "static/media/dettagli2.0fc49286.jpg";